import { render, staticRenderFns } from "./AutoSlide.vue?vue&type=template&id=15480744&scoped=true&"
import script from "./AutoSlide.vue?vue&type=script&lang=js&"
export * from "./AutoSlide.vue?vue&type=script&lang=js&"
import style0 from "./AutoSlide.vue?vue&type=style&index=0&id=15480744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15480744",
  null
  
)

export default component.exports